
export default {
  props: {
    productCompareBanner: {
      type: Object,
      default: () => {},
    },
  },
}
